import React from "react";
import BackButton from "./BackButton";
import { DeleteButton, SaveButton, Toolbar, useNotify, useRedirect, useResourceContext, Confirm } from "react-admin";

const classes = { toolbarButton: { marginLeft: "1rem" } };

const LVToolbar = ({ goBack, saveButton = true, deleteButton = true, backButton = true, ...props }) => {
    const { mutationMode, redirect: redirectTo, basePath } = props;

    const resource = useResourceContext(props);

    const notify = useNotify();
    const redirect = useRedirect();

    return (
        <Toolbar {...props}>
            {saveButton && <SaveButton sx={classes.toolbarButton} disabled={props.pristine} />}

            {deleteButton && (
                <DeleteButton
                    sx={classes.toolbarButton}
                    mutationOptions={{
                        onSuccess: () => {
                            notify("ra.notification.deleted", {
                                type: "info",
                                messageArgs: { smart_count: 1 },
                                undoable: mutationMode === "undoable",
                            });
                            redirect(redirectTo, basePath || `/${resource}`);
                        },
                        onError: (error) => {
                            notify(error?.body?.message || error?.message || "Delete failed", { type: "error" });
                        },
                    }}
                    mutationMode="pessimistic"
                />
            )}

            {backButton && <BackButton sx={classes.toolbarButton} goBack={goBack} />}
        </Toolbar>
    );
};

const LVEditToolbar = (props) => <LVToolbar {...props} />;
const LVCreateToolbar = (props) => <LVToolbar {...props} deleteButton={false} />;

export { LVEditToolbar, LVCreateToolbar };
